

import React from 'react'
import "./imgslid.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Prodcustom from './Prodcustom';

const ProdItems = () => {
  return (
    <Prodcustom url="https://kiwi-discovered-pyjama.glitch.me/prod_top"/>
  )
}

export default ProdItems